module.exports = __webpack_public_path__ + "static/media/lyu_logo.22893179.svg";